import React from "react";
import { Redirect } from "react-router-dom";
import { useAuth } from "../hooks";

const GuestGuard = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Redirect to="/messaging" />;
  }

  return <>{children}</>;
};

export default GuestGuard;
